import React from 'react';
import { useSelector } from 'react-redux';
import BannerTopComponent from '../bannerTopComponent/BannerTopComponent';
import classes from './FinalBannerBeforeAnnouncementCharedi.module.css';

const FinalBannerBeforeAnnouncementCharedi = () => {

  const { texts } = useSelector((state) => state.translate);

  return (
    <BannerTopComponent title={texts.finalBannerTitleCharedi} colorBackground="#DEDEDE">
      <div className={classes.bannerBottomContent}>
        <p className={classes.bannerBottomContentTitle}>{texts.beforeAnnouncementCharediText}</p>
      </div>
    </BannerTopComponent>
  );
};

export default FinalBannerBeforeAnnouncementCharedi;
